import React, { useEffect, useRef } from 'react';
import './style.css';

function Logo() {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const gold = '#C9A84C';
    document.fonts.ready.then(() => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = gold;
      ctx.font = '300 110px "Cormorant Garamond"';
      ctx.fillText('S', 10, 120);
      const sw = ctx.measureText('S').width;
      ctx.font = '300 70px "Cormorant Garamond"';
      ctx.fillText('Q', 10 + sw - 26, 130);
    });
  }, []);
  return <canvas ref={canvasRef} width={200} height={140} className="sq-logo" aria-label="SQ" />;
}

function App() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="App">

      <nav>
        <div className="nav-inner">
          <span className="nav-logo">SCHUH QUANTITATIVE</span>
          <a href="#contact" className="nav-cta">Contact</a>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-inner">
          <Logo />
          <h1 className="hero-headline">Systematic. Quantitative.</h1>
        </div>
      </section>

      <section className="about fade-in" id="about">
        <div className="section-inner">
          <span className="section-label">About</span>
          <div className="section-body">
            <p>Schuh Quantitative is an independent systematic trading firm operating a diversified ensemble of algorithmic strategies in CME Micro E-mini Nasdaq futures.</p>
            <p>The firm trades exclusively proprietary capital, applying quantitative methods to develop, test, and deploy rules-based trading systems across multiple timeframes and market regimes.</p>
          </div>
        </div>
      </section>

      <section className="approach fade-in" id="approach">
        <div className="section-inner">
          <span className="section-label">Approach</span>
          <div className="pillars">
            <div className="pillar">
              <h3>Systematic Execution</h3>
              <p>Every trade is governed by pre-defined rules. No discretionary overrides. Entries, exits, position sizing, and risk management are fully algorithmic.</p>
            </div>
            <div className="pillar">
              <h3>Ensemble Methodology</h3>
              <p>No single strategy dominates the portfolio. Risk is distributed across a large ensemble of uncorrelated models, reducing dependence on any one regime or signal type.</p>
            </div>
            <div className="pillar">
              <h3>Rigorous Research</h3>
              <p>Strategy development follows a structured process: hypothesis, historical validation, stress testing, and phased live deployment. New strategies earn their allocation.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="disclosure fade-in" id="disclosure">
        <div className="section-inner">
          <span className="section-label">Disclosure</span>
          <div className="section-body disclosure-body">
            <p>Schuh Quantitative is not registered as an investment adviser or commodity trading adviser with any federal or state regulatory authority. The firm trades solely on a proprietary basis and does not manage outside capital or solicit investors.</p>
            <p>This website is for informational purposes only and does not constitute an offer or solicitation to buy or sell any security or futures contract. Past performance is not indicative of future results. Futures trading involves substantial risk of loss.</p>
          </div>
        </div>
      </section>

      <section className="contact fade-in" id="contact">
        <div className="section-inner">
          <span className="section-label">Contact</span>
          <p className="contact-line">General inquiries welcome.</p>
          <a href="mailto:contact@schuhquantitative.com" className="email-link">contact@schuhquantitative.com</a>
        </div>
      </section>

      <footer>
        <div className="footer-inner">
          <p>© 2026 Schuh Quantitative. All rights reserved.</p>
        </div>
      </footer>

    </div>
  );
}

export default App;
